import { gql } from '@apollo/client';
const REMOVE_PRODUCT_MAIN_CATEGORY = gql `
  mutation RemoveProductMainCategory($productMainCategoryId: ID!) {
    removeProductMainCategory(productMainCategoryId: $productMainCategoryId) {
      removed
    }
  }
`;
export default REMOVE_PRODUCT_MAIN_CATEGORY;
